import { AdvancedTargetingDefinition } from '../../models/advanced-targeting-definition.model';
import { Quota, QuotaCriteria } from '../../models/survey-quota.model';

// Confirmed on the wire (a live survey's quotas response): the backend tags every
// Advanced-Targeting-sourced quota with this exact value.
const ADVANCED_TARGETING_QUOTA_CATEGORY = 'advance';

// Seeds the Quota Drawer the first time "Add Quotas" is used for a definition: one
// zero-allocated Quota per selected option, ready for the user to distribute completes across.
// Client-only until Apply — nothing here reaches the server. Option labels come from the
// caller's currently cached question data; there is no fetch-question-by-id endpoint, so an
// uncached option falls back to its raw id (same tradeoff AdvancedTargetingDrawerPresenter.edit
// already makes).
export function buildAdvancedTargetingQuotas(
  definition: AdvancedTargetingDefinition,
  optionLabelsById: Record<string, string> = {},
): Quota[] {
  const qualificationCode = Number(definition.attributeId);

  return definition.selectedOptionIds.map((optionId) => {
    const criterion: QuotaCriteria = {
      qualificationCode,
      qualificationName: definition.title,
      conditionCodes: [optionId],
      conditionNames: [optionLabelsById[optionId] ?? optionId],
      originalMaximum: 0,
      originalMinimum: 0,
      originalPercentage: 0,
      originalRequiredCount: 0,
      originalNumber: 0,
      originalFlex: { enable: false, value: 0 },
    };

    return {
      buyerQuotaId: `${definition.attributeId}-${optionId}`,
      groupKey: definition.title,
      requiredCount: 0,
      flexible: { enable: false, value: 0 },
      criteria: [criterion],
      percentage: 0,
      maximum: 0,
      minimum: 0,
      quotaCategory: ADVANCED_TARGETING_QUOTA_CATEGORY,
      currentTarget: 0,
      fielded: 0,
    };
  });
}
